import { Show } from './show.component';

export default Show;
